export default __webpack_public_path__ + "static/media/account-image.c0acc42c.png";